import React from 'react';
import IconButton from '../../atoms/Buttons/IconButton';
import InputAdornment from '../../atoms/InputAdornment';
import MuiFaIcon from '../../atoms/MuiFaIcon';
import Input, { InputProps } from '../../atoms/Input';

type SearchFieldProps = Omit<InputProps, 'label'> & {
  placeholder: string;
};

export default function SearchField({
  placeholder,
  value,
  setValue,
  ...rest
}: SearchFieldProps) {
  return (
    <Input
      label={placeholder}
      value={value}
      setValue={setValue}
      size="small"
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <MuiFaIcon
                name="fa-solid fa-magnifying-glass"
                fontSize="small"
                sx={{ color: 'text.secondary' }}
              />
            </InputAdornment>
          ),
          endAdornment: value ? (
            <InputAdornment position="end">
              <IconButton
                aria-label="clear search"
                onClick={(): void => setValue('')}
                edge="end"
                size="small"
              >
                <MuiFaIcon
                  name="fa-solid fa-xmark"
                  sx={{ fontSize: 16, color: 'text.secondary' }}
                />
              </IconButton>
            </InputAdornment>
          ) : null,
        },
      }}
      {...rest}
    />
  );
}
